module.exports = __webpack_public_path__ + "static/img/er-wei-tu-zhi.b70c689.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/er-wei-tu-zhi.png
// module id = hd+h
// module chunks = 3